module.exports = __webpack_public_path__ + "media/common/images/innogy_rocket-8a937ef568ee4ebcc30ea52c10b699bd.svg";